import { Component, forwardRef, EventEmitter, OnInit, Input, Output } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';
import { Message, OverlayPanel, SelectItem } from 'primeng/primeng';

import * as ent from '../../entities/index'
import * as filters from '../../filters/index'
import * as serv from '../../services/index'

//constants
import { Constants } from '../../constants/Constants';

//base
import { BaseDropdownComponent } from '../../baseclasses/BaseDropdown.component';

@Component({
    selector: 'my-validation-type-dropdown',
    templateUrl: './ValidationTypeDropdown.component.html',
    providers: [{ provide: BaseDropdownComponent, useExisting: forwardRef(() => ValidationTypeDropdownComponent) }]
})
export class ValidationTypeDropdownComponent extends BaseDropdownComponent {

    records: ent.ValidationType[] = [];
    constructor(private domainDataService: serv.DomainDataService) {
        super();
    }


    ngOnInit(): void {
    }

    public load() {

        this.domainDataService.getValidationTypes({ IncludeInactive: false }).subscribe(x => this.onGetRecordsDone(x));
    }

    onGetRecordsDone(items: ent.ValidationType[]) {
        this.records = items;
        this.selectItems.push({ label: "", value: Constants._NONE });
        items.forEach(y => this.selectItems.push({ label: y.Name, value: y.ID }));
        if (this.selectedID) {
            this.value = this.selectedID;
        }

    }

}